import React, { useState } from 'react';
import { Background } from '../UiKit/Background';
import { Preview } from '../UiKit/Preview';
import { getPentaDesign } from '../utilsPenta';
import { PentaBodyPlanets } from './PentaBodyPlanets';
import { sample } from 'lodash';


export function PentaBody({
  lines = true,
  composite,
  markers,
  planets,
  preview = 'comp',
  penta = {},
  parentContainer,
  className = 'x_bodygraph_body',
  handleClick,
  setPreview,
  aura,
  numbers,
  png = false,
  mode3d,
  appear3d,
}) {

  const [temp, setTemp] = useState()

  // const pentaDesign = penta.pentaDesign || {
  //   ...getPentaDesign(penta)
  // }
  const pentaDesign = penta.pentaDesign;

  return (
    <>

      {Boolean(handleClick) &&
        <div style={{ zIndex: 100 }}
          className="x_choose_hover" onClick={handleClick}>
        </div>
      }



      <div
        className={className}
        onClick={handleClick}
      >



        {planets && <PentaBodyPlanets
          colorTheme={'composite1'}
          setPreview={(previewId) => {
            setPreview(previewId)
            setTemp(previewId)
          }}
          penta={penta}
          preview={preview}
          label='des'
        />}

        <div
          className={(penta.members[0] && preview === 0)
            ? `x_body_comp_preview inact active`
            : "x_body_comp_preview inact"}
        >
          <Preview
            lines={lines}
            numbers={true}
            parentContainer={parentContainer}
            design={penta.members[0].avatar.design}
            png={png}
            avatarToken={penta.members[0].avatar.token}
            avatarUpdated={penta.members[0].avatar.updated}
          />
        </div>

        {penta.members[1] && <div
          className={(penta.members[1] && preview === 1)
            ? `x_body_comp_preview inact active`
            : "x_body_comp_preview inact "}
        >
          <Preview
            lines={lines}
            numbers={true}
            parentContainer={parentContainer}
            design={penta.members[1].avatar.design}
            png={png}
            avatarToken={penta.members[1].avatar.token}
            avatarUpdated={penta.members[1].avatar.updated}
          />
        </div>}


        <Preview
          mode3d={mode3d}
          appear3d={appear3d}
          lines={lines}
          hoverable={true}
          penta={penta}
          markers={markers}
          composite={composite}
          // planets={true}
          numbers={numbers}
          design={pentaDesign}
          aura={false}
          // width={60}
          // height={80}
          addClassName='penta'
          parentContainer={parentContainer}
        />


        {planets && <PentaBodyPlanets
          colorTheme={'composite2'}
          setPreview={(previewId) => {
            setPreview(previewId)
            setTemp(previewId)
          }}
          penta={penta}
          preview={preview}
          label='prs'
        />}


      </div>

      {/* {aura && <Background
        design={getPentaDesign(penta)}
      />} */}
    </>
  )
}



